/* eslint-disable no-shadow */
export enum BadRequest {
  MAJOR = 100,
  VALIDATION = 101,
  RESOURCE_UNKNOWN = 103,
}
